import React from 'react';
import MissionStatement from './MissionStatement';
import AIChat from './AIChat';
import QuoteRandomizer from './QuoteRandomizer';
import './Tech.css';

const Tech = () => {
    return (
        <div className="tech-container">
            <div className="tech-section">
                <MissionStatement />
            </div>
            
            <div className="tech-section">
                <AIChat />
            </div>
            
            <div className="tech-section">
                <QuoteRandomizer />
            </div>
        </div>
    );
};

export default Tech; 